// custom code
let total = 0;
function change_text (change,main_parent,limit){    
if(main_parent){
const footerbutton = main_parent.querySelector('.footer_button button')
footerbutton.innerText = `${change} of ${limit} valda objekt`    
}          
}
$('.collections-products .collections-tabs button').click(function() {
  $(this).addClass('active-button').siblings().removeClass('active-button');

  var col = $(this).attr('coll');
  var $leftDetails = $(this).parents('.left-details');

  $leftDetails.find('.appendtitle').text(col);

  $leftDetails.find('ul.products-loop ul li').each(function () {
    var $this = $(this);
    var colHandle = $this.attr('col_handle');
    var tags = $this.attr('col_tags');

    if (col === 'All') {
      $this.show();
    } else {
      var matchByHandle = (colHandle && colHandle.toLowerCase() === col.toLowerCase());
      var matchByTag = false;

      if (tags) {
        // convert tags string into array and trim spaces
        var tagsArray = tags.split(',').map(tag => tag.trim().toLowerCase());
        matchByTag = tagsArray.includes(col.toLowerCase());
      }

      // ✅ Show product if either matches (OR condition)
      if (matchByHandle || matchByTag) {
        $this.show();
      } else {
        $this.hide();
      }
    }
  });
});

$('.search-button-here').click(function() {
$(this).find('.custom-products-section').addClass('active-drawer');
$('.header-section').addClass('active_header')
$('body').addClass('active-Drawer-overlay');
})
$('.main-Srach-boc.custom_drawer_open').click(function() {
$('div#append_here_serach_bar .search-button-here:first-child .container.custom-products-section').addClass('active-drawer');
$('body').addClass('active-Drawer-overlay');
})
const Content_active =[]
function active_tabs_content(main_parent,limit,ml_) { 
let slectorr  = main_parent.querySelectorAll('li.cards-products.activate_li')
if(slectorr.length===0){
Content_active.length=0
}else{
Content_active.length=0
slectorr.forEach((item, index) => {
if(item){
const data_title = item.getAttribute('data-title');
const inputValue = item.querySelector('input').value;
for (let index = 1; index <= inputValue; index++) {
if(data_title && data_title!==''){
Content_active.push( {name:data_title})
}
}             
}                           
});
}
document.querySelectorAll(`.search-button-here[data-ml="${ml_}"] .main-Srach-boc`).forEach((item,index) => {
if (index < Content_active.length) {
let title =  Content_active[index].name
const inner = `<div class="appended_content"><div class="h5">${title}</div></div>`
item.innerHTML = inner
}else {
item.innerHTML = `<div> <span class="inline-flex align-middle text-gray-400 js-bundle-select-search-icon relative -top-[1px]" aria-hidden="true"> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"> <circle cx="11" cy="11" r="8"></circle> <line x1="21" y1="21" x2="16.65" y2="16.65"></line> </svg> </span> </div> <div data-selected-product="" class="text-sm uppercase">Sök här...</div>`
}
});
}
$('._closeButton_1m5ps_20 ,#add_to_carts').click(function(e) {
const main_parent = e.target.closest('.left-details.step-first')
var limit = parseInt(main_parent.getAttribute('data-limit'))
var ml_ = main_parent.getAttribute('data-ml')
active_tabs_content(main_parent,limit,ml_)
var thisss = $(this)
setTimeout(function(){
$('body').removeClass('active-Drawer-overlay');
$('.header-section').removeClass('active_header')
thisss.parents('.custom-products-section').removeClass('active-drawer');
}, 100);         
})
function disable_all_feilds(condition,parents){
if(parents){      
parents.querySelectorAll('li').forEach((items)=>{
if (items.classList.contains('activate_li')) {
return;
}
if(condition){
items.classList.add('disbaled')
}else{
items.classList.remove('disbaled')
}    
}) 
if(condition){
parents.querySelectorAll('.flex.activate button[data-quantity-add]').forEach((button) => {
button.classList.add('disabled');
});
parents.querySelector('#add_to_carts').style.display = 'flex';
parents.querySelector('#Choose_button').style.display = 'none';
}else{
parents.querySelectorAll('.flex.activate button[data-quantity-add]').forEach((button) => {
button.classList.remove('disabled');
});
parents.querySelector('#add_to_carts').style.display = 'none';
parents.querySelector('#Choose_button').style.display = 'block';
}
}      
}
function addClass_for_disables(parents, limit) {
let total = 0; 
parents.querySelectorAll('li').forEach((item) => {
let limit = item.querySelector('.flex.activate input')?.value;
limit = parseFloat(limit) || 0; 
total += limit;
});
return total;       
}
$('.bundle_selected').click(function(e) {       
const main_parent = e.target.closest('.left-details.step-first')
console.log(main_parent)
var limit = parseInt(main_parent.getAttribute('data-limit'))
console.log(limit)
var $input = $(this).parents('.pl-3').find('input');
$input.val(parseInt($input.val()) + 1);
$(this).hide();
$(this).parents('.pl-3').find('.flex').addClass('activate');
$(this).parents('.cards-products').addClass('activate_li');
total = addClass_for_disables(main_parent, limit)
change_text(total,main_parent, limit)
if (limit === total) {
disable_all_feilds(true,main_parent)
return true;
} else {     
disable_all_feilds(false,main_parent)
}
})
$('button.border.text-black[data-quantity-remove]').click(function (e) {
const main_parent_left = e.target.closest('.left-details.step-first')
var limit = parseInt(main_parent_left.getAttribute('data-limit'))
var $input = $(this).parent().find('input');
var count = parseInt($input.val()) - 1;
count = count < 0 ? 0 : count;
$input.val(count);
$input.change();      
disable_all_feilds(false)
if(count < 1){
$(this).parents('.pl-3').find('.flex').removeClass('activate');
$(this).parents('.pl-3').find('.bundle_selected').show();
$(this).parents('.cards-products').removeClass('activate_li');
}
if (parseInt($input.val()) < limit) {
$(this).parents('.flex').find('button[data-quantity-add]').removeClass('disabled')
}
total = addClass_for_disables(main_parent_left, limit)
change_text(total,main_parent_left,limit)
if (limit === total) {
disable_all_feilds(true,main_parent_left)
} else {     
disable_all_feilds(false,main_parent_left)
}
});
$('button.border.text-black[data-quantity-add]').click(function (e) {
          const main_parent_left = e.target.closest('.left-details.step-first')
          var limit = parseInt(main_parent_left.getAttribute('data-limit'))
          var $input = $(this).parent().find('input');
          $input.val(parseInt($input.val()) + 1);
          $input.change();
          if (limit === parseInt($input.val())) {
          $(this).addClass('disabled')
          disable_all_feilds(true,main_parent_left)
          change_text($input.val(),main_parent_left,limit)
          return true;
          } else {     
          $(this).removeClass('disabled')
          change_text($input.val(),main_parent_left,limit)
          disable_all_feilds(false,main_parent_left)
          }        
         total = addClass_for_disables(main_parent_left, limit)
        if (limit === total) {
          disable_all_feilds(true,main_parent_left)
          } else {     
          disable_all_feilds(false,main_parent_left)
          }
      });

// before
let input = document.querySelectorAll(".input_search_bar input[type=text]").forEach((input) => {
input.addEventListener('input', search);
});
function search(e) {
const eventarget = e.target.closest('.custom-products-section')
let input = eventarget.querySelector(".input_search_bar input[type=text]");
let list = eventarget.querySelectorAll(".search_resultsss li");
let searchresult = eventarget.querySelector('.header-search-result ul.search_resultsss');
let datanotfount = eventarget.querySelector(".data-no-results");
let inputValue = input.value.trim().toLowerCase();
if (inputValue === "") {
searchresult.style.display = "none";
datanotfount.style.display = "none";
return;
}
let found = false;
for (let i = 0; i < list.length; i += 1) {
if (list[i].innerText.toLowerCase().includes(inputValue)) {
list[i].style.display = "flex";
found = true;
} else {
list[i].style.display = "none";
}
}
if (found) {
searchresult.style.display = "block";
datanotfount.style.display = "none";
} else {
searchresult.style.display = "none";
datanotfount.style.display = "flex";
}
}
let total_bundle = null;
if (document.querySelector('.product__submit__buttons')) {
  total_bundle = parseInt(document.querySelector('.product__submit__buttons').getAttribute('total-bundle'), 10);
}
let product_type = {};
let __product_type = [];
let productIndex = 1;
const searchBar = document.querySelectorAll('.product__submit__buttons button.custom_add_to_Cart, #add_to_carts');
// if (searchBar) {
//   searchBar.forEach((button) => {
//     button.addEventListener('click', function (event) {
//       const main_id = this.getAttribute('main-id');
//       product_type = {};
//       __product_type = [];
//       productIndex = 1;
//       document.querySelectorAll('#append_here_serach_bar .custom-products-section').forEach((parentElement) => {
//             parentElement.querySelectorAll('li.cards-products.activate_li').forEach((item, index) => {
//               const prdid = item.getAttribute('data-id');
//               const data_title = item.getAttribute('data-title');
//               const inputValue = item.querySelector('input').value;
//               const Ml_title = item.getAttribute('var_title');
//               const productKey = `Parfym ${productIndex} (${Ml_title}) X ${inputValue}`;
//               // const productKey = `Parfym ${productIndex} (${Ml_title})`;
//               const secproduct = {
//                 id: prdid,
//                 qty: inputValue,
//                 name: data_title
//               };              
//               product_type[productKey]=data_title
//               __product_type[productIndex] = secproduct;
//               productIndex++; 
//             });
//         });
//         addToCart(main_id);
//     });
//     });
// }
if (searchBar) {
  searchBar.forEach((button) => {
    button.addEventListener('click', function (event) {
      const main_id = this.getAttribute('main-id');
      product_type = {};
      __product_type = []; // array
      productIndex = 1;

      document.querySelectorAll('#append_here_serach_bar .custom-products-section')
        .forEach((parentElement) => {
          parentElement.querySelectorAll('li.cards-products.activate_li')
            .forEach((item, index) => {
              const prdid = item.getAttribute('data-id');
              const data_title = item.getAttribute('data-title');
              const inputValue = item.querySelector('input').value;
              const Ml_title = item.getAttribute('var_title');

              const productKey = `Parfym ${productIndex} (${Ml_title}) X ${inputValue}`;

              const secproduct = {
                id: prdid,
                qty: inputValue,
                name: data_title
              };

              product_type[productKey] = data_title;
              __product_type.push(secproduct); // ✅ use push instead of index assign
              productIndex++;
            });
        });

      console.log("__product_type:", __product_type); // ✅ now will show array of objects
      console.log("product_type:", product_type);

      addToCart(main_id);
    });
  });
}

// async function addToCart(main_id) {
//     const appended_totale = document.querySelectorAll('.appended_content').length
//     if (Object.keys(product_type).length === 0) {
//     alert('No products Selected');
//     return;
//     } 
//     else if (appended_totale !== total_bundle) {
//         alert(`${total_bundle - appended_totale} more Product(s) to Select`);
//         return;
//     }
//   console.log(product_type,'product_type')
//    const formdata = {
//         items: [{
//             id: main_id,
//             quantity: 1,
//             properties:{
//               ...product_type,
//               __product_type                 
//            }
//         }]
//     };
//     console.log('Form Data:', formdata);
  
//     try {
//         const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(formdata)
//         });
//         if (!response.ok) {
//             throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const data = await response.json();
//         // jQuery.getJSON('/cart.js', (e) => {
//         // document.querySelector('[data-product-add-popdown-wrapper]').dispatchEvent(new CustomEvent("theme:cart:popdown", { detail: { variant: e }, bubbles: !0 }));
//         // document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: e }, bubbles: !0 }));
//         // })
//         jQuery.getJSON('/cart.js', function(cartData) {
//         const popdownWrapper = document.querySelector('[data-product-add-popdown-wrapper]');
//         if (popdownWrapper) {
//           popdownWrapper.dispatchEvent(new CustomEvent("theme:cart:popdown", {
//             detail: { variant: response },
//             bubbles: true
//           }));
//         }

//         document.dispatchEvent(new CustomEvent("theme:cart:change", {
//           detail: { cart: cartData },
//           bubbles: true
//         }));
//       });
//         console.log('All products added to cart');
//     } catch (error) {
//         console.log('Error=====>', error);
//     }
// }


async function addToCart(main_id) {
  const appended_totale = document.querySelectorAll('.appended_content').length;

  if (Object.keys(product_type).length === 0) {
    alert('No products Selected');
    return;
  } else if (appended_totale !== total_bundle) {
    alert(`${total_bundle - appended_totale} more Product(s) to Select`);
    return;
  }

  console.log('Selected product_type:', product_type);

  const productForm = document.querySelector('product-form-component');
  if (!productForm) {
    console.error('ProductFormComponent not found. CartAddEvent will not trigger.');
    return;
  }

  const tempForm = document.createElement('form');
  tempForm.innerHTML = `
    <input type="hidden" name="id" value="${main_id}">
    <input type="hidden" name="quantity" value="1">
  `;

  // Add each property
  for (const key in product_type) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${key}]`;
    input.value = product_type[key];
    tempForm.appendChild(input);
  }

  // ✅ Properly stringify __product_type
  const specialInput = document.createElement('input');
  specialInput.type = 'hidden';
  specialInput.name = 'properties[__product_type]';
  specialInput.value = JSON.stringify(__product_type); // ✅ FIX
  tempForm.appendChild(specialInput);

  // Append to product form and submit
  productForm.appendChild(tempForm);
  productForm.handleSubmit(new Event('submit', { bubbles: true, cancelable: true }));

  setTimeout(() => tempForm.remove(), 100);

  // Optional fly-to-cart animation
  const addToCartButton = productForm.querySelector('[ref="addToCartButton"]');
  if (addToCartButton) {
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    const image = addToCartButton.dataset.productVariantMedia;
    if (cartIcon && image) {
      const flyToCartElement = document.createElement('fly-to-cart');
      flyToCartElement.style.setProperty('background-image', `url(${image})`);
      flyToCartElement.source = addToCartButton;
      flyToCartElement.destination = cartIcon;
      document.body.appendChild(flyToCartElement);
    }
  }

  console.log('Bundle submitted to ProductFormComponent for cart addition.');
}

